import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogModal from "@/components/dialogModal";
import Loader from "@/components/loader";
import { StoreLocatorContext } from "@/routes/storeLocator/storeLocator";
import { LOADER_TYPES } from "@/constants";
import "./style.scss";

const StoreLocatorDetails = ({ mapVisible }) => {
  const [showGeoLoader, setShowGeoLoader] = useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [userGeolocation, setUserGeolocation] = useState(null);

  const { t } = useTranslation("storeLocator");
  const { selectedShop } = useContext(StoreLocatorContext);

  const findGeolocation = () => {
    setShowGeoLoader(true);

    !navigator.geolocation
      ? console.error("Geolocation is not supported by your browser")
      : navigator.geolocation.getCurrentPosition(success, error);
  };

  useEffect(() => {
    findGeolocation();
  }, []);

  const success = position => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    setUserGeolocation({ latitude, longitude });
    setShowGeoLoader(false);
  };

  const error = () => setShowGeoLoader(false);

  const getLocationTitle = mapVisible ? t("showStore") : t("getDirection");

  const getLocationElement = userGeolocation ? (
    <a
      className="get-direction"
      href={`https://www.google.com/maps/dir/?api=1&travelmode=driving&dir_action=navigate&destination=${selectedShop.lat}%2C${selectedShop.lng}&origin=${userGeolocation.latitude}%2C${userGeolocation.longitude}`}
      target="_blank"
    >
      {getLocationTitle}
    </a>
  ) : (
    <button
      className="get-direction"
      onClick={() => setShowPermissionModal(true)}
    >
      {getLocationTitle}
    </button>
  );

  return (
    <div className="store-locator-details-container">
      <div className="store-location-name">
        {`${selectedShop.name}`.toLocaleLowerCase() || ""}
      </div>
      <div className="store-name">
        {`${selectedShop.description}`.toLocaleLowerCase() || ""}
      </div>
      <div className="address-header">{t("address")}</div>
      <div className="address-details">
        <div className="address">{selectedShop.address || ""}</div>
        {(selectedShop.country || selectedShop.city) && (
          <div className="store-email">
            {selectedShop.city}, {selectedShop.country}
          </div>
        )}
      </div>

      {showGeoLoader ? (
        <Loader
          type={LOADER_TYPES.RING}
          width={25}
          height={25}
          visible
          style={{ marginTop: "20px" }}
        />
      ) : (
        <div className="get-direction-block">{getLocationElement}</div>
      )}

      <DialogModal
        bodyText={t("locationAccess")}
        cancelButtonText={t("ok")}
        onCancel={() => setShowPermissionModal(false)}
        showModal={showPermissionModal}
      />
    </div>
  );
};

export default StoreLocatorDetails;
